export const GET_PROPERTIES = "GET_PROPERTIES";

export const GET_FEATURED_PROPERTIES = "GET_FEATURED_PROPERTIES";

export const GET_PROPERTY = "GET_PROPERTY";
